import { render, staticRenderFns } from "./Practices.vue?vue&type=template&id=1712b050"
import script from "./Practices.vue?vue&type=script&lang=ts"
export * from "./Practices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports